const initPrint = () => {
  window.onbeforeprint = function() {
    var images = document.getElementsByTagName('img');
    for (var i = 0; i < images.length; i++) {
        var img = images[i];
        if (img.getAttribute('loading') === 'lazy') {
            img.removeAttribute('loading');
        }
        if (img.classList.contains('lazyload')) {
            img.classList.remove('lazyload');
        }
        if (img.getAttribute('data-src')) {
            img.setAttribute('src', img.getAttribute('data-src'));
        }
    }
  };
};

export default initPrint;
